<template>
    <router-link
            v-if="show"
            :to="to"
            :target="target"
            class="link-entity"
    >
        <v-icon>mdi-link</v-icon>
    </router-link>
</template>

<script>
    export default {
        props: {
            to: {type: Object},
            target: {type: String, default: '_self'}
        },
        computed: {
            show() {
                return typeof this.to.params.id === 'number';
            }
        }
    }
</script>

<style lang="scss">
    .link-entity {
        text-decoration: none;
    }
</style>